import { transitions as _transitions } from './theme';
const transitions = {
    short: _transitions[0],
    medium: _transitions[1],
    long: _transitions[2],
};
export { transitions };
//# sourceMappingURL=animation.js.map
